import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { errMessage } from "@/lib/api";

export default function AuthCallback() {
  const { googleSession } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/auth");
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    googleSession(sessionId)
      .then(() => {
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/profile");
      })
      .catch((err) => {
        toast.error(errMessage(err, "Google sign-in failed. Please try again."));
        navigate("/auth");
      });
  }, [googleSession, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-ink">
      <div className="font-mono text-xs uppercase tracking-[0.3em] text-ash animate-pulse">Opening the Haus…</div>
    </div>
  );
}
